import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, NavLink } from 'react-router-dom';
import { push } from 'connected-react-router';
import { CssBaseline, Box, Grid, Typography, Button, CircularProgress, Tooltip, Avatar } from '@mui/material';
import PersonIcon from '@mui/icons-material/PersonPin';
import { fetchPromotion } from 'actions/PromotionActions';
import renderHTML from 'html-react-parser';
import LandingPage from './LandingPage';
import PromoContentPage from './PromoContentPage';
import AgeGatePage from './AgeGatePage';
import PreparationCheckModal from 'components/PreparationCheckModal';

const NavButton = ({children}) => (
  <Button component="div" role="none" tabIndex={-1}>{children}</Button>
);

export class PromoPage extends React.Component {
  componentDidMount() {
    if (window.PROMO_ID) {
      this.props.fetchPromotion(window.PROMO_ID);
    }
  }

  componentDidUpdate(prevProps) {
    const { promotion, navigateTo } = this.props;

    // Navigate to claim page if promotion is closed to show closed message
    if (promotion !== prevProps.promotion && promotion && !promotion.open) {
      navigateTo('/claim');
    }
  }

  renderLinks() {
    const { promotion } = this.props;

    return (
      <React.Fragment>
        {(promotion.terms_and_conditions.url || promotion.terms_and_conditions.content) &&
          (promotion.terms_and_conditions.external ?
            <a href={promotion.terms_and_conditions.url} target="_blank"><NavButton>Terms and Conditions</NavButton></a>
          :
            <NavLink exact to={{pathname: '/terms', search: this.props.location.search}} activeClassName="active" aria-current="page"><NavButton>Terms and Conditions</NavButton></NavLink>
          )
        }
        {(promotion.privacy_policy.url || promotion.privacy_policy.content) &&
          (promotion.privacy_policy.external ?
            <a href={promotion.privacy_policy.url} target="_blank"><NavButton>{promotion.privacy_policy.label || 'Privacy Policy'}</NavButton></a>
          :
            <NavLink exact to={{pathname: '/privacy_policy', search: this.props.location.search}} activeClassName="active" aria-current="page"><NavButton>{promotion.privacy_policy.label || 'Privacy Policy'}</NavButton></NavLink>
          )
        }
        {(promotion.faqs.url || promotion.faqs.content) &&
          (promotion.faqs.external ?
            <a href={promotion.faqs.url} target="_blank"><NavButton>FAQ</NavButton></a>
          :
            <NavLink exact to={{pathname: '/faq', search: this.props.location.search}} activeClassName="active" aria-current="page"><NavButton>FAQ</NavButton></NavLink>
          )
        }
        {promotion.custom_tabs.map((custom_tab, index) =>
          <React.Fragment key={index}>
            {
              (custom_tab.content_url ?
                <a href={custom_tab.content_url} target="_blank"><NavButton>{custom_tab.label}</NavButton></a>
              :
                <NavLink exact to={{pathname: "/" + custom_tab.path, search: this.props.location.search}} activeClassName="active" aria-current="page"><NavButton>{custom_tab.label}</NavButton></NavLink>
              )
            }
          </React.Fragment>
        ) }
      </React.Fragment>
    )
  }

  render() {
    const { isFetching, promotion, navigateTo, location } = this.props;

    if (!window.PROMO_ID) {
      return (
        <h1>Not found</h1>
      )
    }

    return (
      <React.Fragment>
        <CssBaseline />
        <Grid container justifyContent="center">
          {!promotion || isFetching ?
            <Grid container spacing={16} justifyContent="center">
              <CircularProgress aria-label="Loading promotion" />
            </Grid>
          :
            <Switch>
              {promotion.age_gate_enabled && !localStorage.getItem('age_verification') &&
                <Route render={() => <AgeGatePage promotion={promotion} />} />
              }
              <Route exact path='/' render={() => <LandingPage promotion={promotion} />} />
              <Route render={() => <PromoContentPage promotion={promotion} />} />
            </Switch>
          }
        </Grid>
        <Grid container justifyContent="center">
          {promotion &&
            <Grid className="terms" size={{xs: 8}}>
              <Typography variant="caption" component="div" gutterBottom>
                {renderHTML(promotion.disclaimer)}
              </Typography>
              <div className="link-container">
                {promotion && promotion.has_preparation_checks ?
                  <PreparationCheckModal promotion={promotion} onSubmit={() => navigateTo('/claim' + location.search)}
                    openComponent={(props) =>
                      <NavLink exact to={{pathname: '/claim'}} activeClassName="active" {...props}>
                        <Button component="div" tabIndex={-1} onClick={(e) => e.preventDefault()}>{promotion.competition ? 'Enter' : 'Claim'}</Button>
                      </NavLink>
                    }
                  />
                :
                  <NavLink exact to={{pathname: '/claim', search: location.search}} activeClassName="active" aria-current="page">
                    <NavButton>{promotion.competition ? 'Enter' : 'Claim'}</NavButton>
                  </NavLink>
                }
                {promotion.trackable &&
                  <NavLink exact to={{pathname: '/track', search: location.search}} activeClassName="active" aria-current="page">
                    <NavButton>Track</NavButton>
                  </NavLink>
                }
                {this.renderLinks()}
                <NavLink exact to={{pathname: '/contact', search: location.search}} activeClassName="active" aria-current="page">
                  <NavButton>Contact us</NavButton>
                </NavLink>
              </div>
              <Typography variant="caption" gutterBottom className="gutter-top">
                Powered by WAIVPAY
              </Typography>
            </Grid>
          }
        </Grid>
        {window.PROMOTION_OPEN_OVERRIDE &&
          <Tooltip title="You are viewing as an administrator">
            <Avatar className="admin-view">
              <PersonIcon />
            </Avatar>
          </Tooltip>
        }
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    ...state.promotion
  };
}

const mapDispatchToProps = {
  fetchPromotion: (id) => fetchPromotion(id),
  navigateTo: (path) => push(path)
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PromoPage));
